import React from "react";
import Banner from "../../components/Banner";
import Footer from "../../components/Footer";
import { Sidebar } from "../../components/Sidebar";
import axios from "axios";
import Spinner from "../../components/Spinner";
import "../../css/Wireframe.css";

const API = localStorage.getItem("assethost");

export default class Register extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      msg: "",
      toastColor: "",
      showVerify: false,

      category: "",
      subcategory: "",
      brand: "",
      model: "",
      uniqueIdentifier1: "",
      uniqueIdentifier2: "",
      serialNumber: "",
      tagNumber: "",
      year: "",
      color: "",
      proofOfOwnership: "",
      ownershipFile: null,
      ownershipDetails: "",
      locationOfMarker: "",
      markerPicture: null,
      descriptionOfMarker: "",
      pictureOfAsset: null,
      documentType: "",
      documentFile: null,
      vehicleRegNumber: "",
      chassisNumber: "",
      vinNumber: "",
      nationalIdNumber: "",
      passportNumber: "",
      driversLicenseNumber: "",
      breed: "",
      animalType: "",
      make: "",
      companyProfileId: sessionStorage.getItem("companyProfileId") || "0",
      individualProfileId: sessionStorage.getItem("individualProfileId") || "0",

      errors: {},

      categories: [],
      subcategories: [],
      proofOfOwnershipOptions: [],
      documentTypeOptions: [],

      assetType: "",
      isForElectronics: false,
      isForElectricals: false,
      isForMechanical: false,
      isForLivestock: false,
      isForFurniture: false,
      isForVehicles: false,
      isForMobile: false,
      isForTools: false,
      title: "Assets – Register",

      valid: true,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.validate = this.validate.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.handleRegister = this.handleRegister.bind(this);
    this.loadDropdowns = this.loadDropdowns.bind(this);
    this.loadSubcategories = this.loadSubcategories.bind(this);
  }

  componentDidMount() {
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }
    this.loadDropdowns(token);
  }

  loadDropdowns(token) {
    this.setState({ loading: true, msg: "", toastColor: "" });
    axios
      .get(API + "/asset/getassetdropdownlist", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const data = response.data || {};
        this.setState({
          categories: data.categorys
            ? data.categorys.map((cat) => {
                return { name: cat.name, subcategories: cat.subcategorys };
              })
            : [],
          proofOfOwnershipOptions: data.ownershipTypes,
          documentTypeOptions: data.documentTypes,
          loading: false,
        });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          loading: false,
          msg: error?.response?.data?.message || "Failed to load dropdowns.",
          toastColor: "danger",
        });
      });
  }

  loadSubcategories(categoryName) {
    let subcategories =
      this.state.categories?.find((cat) => cat.name === categoryName)
        .subcategories || [];
    this.setState({ subcategories });
  }

  decideAssetType() {
    const deciders = {
      isForElectronics: false,
      isForElectricals: false,
      isForMechanical: false,
      isForLivestock: false,
      isForFurniture: false,
      isForVehicles: false,
      isForMobile: false,
      isForTools: false,
      isForTractors: false,
      isForIdentityDocuments: false,
      title: "Assets – Register",
      assetType: "",
    };

    if (this.state.subcategory) {
      const subcategory = this.state.subcategories.find(
        (sub) => Number(sub.id) === Number(this.state.subcategory)
      );
      let titleEnd = "";
      deciders.assetType = subcategory.assetType;

      switch (subcategory.assetType) {
        case "MOBILE":
          titleEnd = " [ Mobile / Tablets]";
          deciders.isForMobile = true;
          break;
        case "ELECTRONICS":
          titleEnd =
            " [ Laptops & computers, Other Electronics, Office Equipment ]";
          deciders.isForElectronics = true;
          break;
        case "ELECTRICAL":
          titleEnd =
            " [ Laptops & computers, Other Electronics, Office Equipment ]";
          deciders.isForElectricals = true;
          break;
        case "MECHANICAL":
          titleEnd = " [ Tools & Equipment, Furniture ]";
          deciders.isForMechanical = true;
          deciders.isForTools = true;
          break;
        case "FURNITURE":
          titleEnd = " [ Tools & Equipment, Furniture ]";
          deciders.isForFurniture = true;
          deciders.isForTools = true;
          break;
        case "VEHICLES":
          titleEnd = " [ Vehicles, Tractors, Motorcycles & Bikes ]";
          deciders.isForVehicles = true;
          break;
        case "ANIMALS":
          titleEnd = " [ Livestock & animals ]";
          deciders.isForLivestock = true;
          break;
        case "TRACTORS":
          titleEnd = " [ Vehicles, Tractors, Motorcycles & Bikes ]";
          deciders.isForTractors = true;
          deciders.isForVehicles = true;
          break;
        case "IDENTITY_DOCUMENTS":
          titleEnd = " [ Identity Documents ]";
          deciders.isForIdentityDocuments = true;
          break;
        default:
          break;
      }
      deciders.title = `Assets – Register${titleEnd}`;
    }

    this.setState({ ...deciders }, this.validate);
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value }, this.validate);
  }

  handleFileChange(e) {
    const { name } = e.target;
    const file = e.target.files ? e.target.files[0] : null;
    this.setState({ [name]: file }, this.validate);
  }

  handleSelectChange(name, value) {
    this.setState({ [name]: value }, () => {
      if (name === "category") {
        this.setState({
          subcategory: "",
          isForElectronics: false,
          isForElectricals: false,
          isForMechanical: false,
          isForLivestock: false,
          isForFurniture: false,
          isForVehicles: false,
          isForMobile: false,
          isForTools: false,
          isForTractors: false,
          isForIdentityDocuments: false,
          title: "Assets – Register",
          assetType: "",
          // Clear asset-specific fields
          uniqueIdentifier1: "",
          uniqueIdentifier2: "",
          serialNumber: "",
          tagNumber: "",
          vehicleRegNumber: "",
          chassisNumber: "",
          vinNumber: "",
          nationalIdNumber: "",
          passportNumber: "",
          driversLicenseNumber: "",
          documentType: "",
          documentFile: null,
        });
        this.loadSubcategories(value);
      }
      this.validate();
      if (name === "subcategory") {
        this.resetState();
        this.decideAssetType();
      }
    });
  }

  validate() {
    const s = this.state;
    let errors = {};
    let valid = true;

    if (!s.category || !s.category.trim()) {
      errors.category = "Category is required";
      valid = false;
    }
    if (!s.subcategory || !s.subcategory.trim()) {
      errors.subcategory = "Subcategory is required";
      valid = false;
    }
    if (s.category && s.subcategory) {
      if (!s.isForLivestock && !s.isForVehicles) {
        if (!s.brand || !s.brand.trim()) {
          errors.brand = "Brand is required";
          valid = false;
        }
      }
      if (!s.isForLivestock) {
        if (!s.model || !s.model.trim()) {
          errors.model = "Model is required";
          valid = false;
        }
      }
      if (s.isForLivestock) {
        if (!s.tagNumber || !s.tagNumber.trim()) {
          errors.tagNumber = "Tag number is required";
          valid = false;
        }
        if (!s.breed || !s.breed.trim()) {
          errors.breed = "Breed is required";
          valid = false;
        }
        if (!s.animalType || !s.animalType.trim()) {
          errors.animalType = "Animal type is required";
          valid = false;
        }
      }
      if (s.isForVehicles) {
        if (!s.make || !s.make.trim()) {
          errors.make = "Make is required";
          valid = false;
        }
        if (!s.vehicleRegNumber || !s.vehicleRegNumber.trim()) {
          errors.vehicleRegNumber = "Registration number is required";
          valid = false;
        }
      }

      if (!s.proofOfOwnership || !s.proofOfOwnership.trim()) {
        errors.proofOfOwnership = "Proof of Ownership is required";
        valid = false;
      }
      if (!s.ownershipFile || !s.ownershipFile.name) {
        errors.ownershipFile = "Ownership File is required";
        valid = false;
      }
      if (!s.locationOfMarker || !s.locationOfMarker.trim()) {
        errors.locationOfMarker = "Location of Marker is required";
        valid = false;
      }
      if (!s.pictureOfAsset || !s.pictureOfAsset.name) {
        errors.pictureOfAsset = "Picture of Asset is required";
        valid = false;
      }
      if (
        s.isForMobile &&
        (!s.uniqueIdentifier1 || !s.uniqueIdentifier1.trim())
      ) {
        errors.uniqueIdentifier1 = "IMEI 1 is required";
        valid = false;
      }
      if (
        (s.isForElectronics || s.isForElectricals) &&
        (!s.serialNumber || !s.serialNumber.trim())
      ) {
        errors.serialNumber = "Serial Number is required";
        valid = false;
      }
      if (
        (s.isForTools || s.isForLivestock) &&
        (!s.tagNumber || !s.tagNumber.trim())
      ) {
        errors.tagNumber = "Tag Number is required";
        valid = false;
      }
    }

    this.setState({ errors, valid });
    return valid;
  }

  resetState() {
    this.setState({
      brand: "",
      model: "",
      uniqueIdentifier1: "",
      uniqueIdentifier2: "",
      serialNumber: "",
      tagNumber: "",
      year: "",
      color: "",
      proofOfOwnership: "",
      ownershipFile: null,
      ownershipDetails: "",
      locationOfMarker: "",
      markerPicture: null,
      descriptionOfMarker: "",
      pictureOfAsset: null,
      documentType: "",
      documentFile: null,
      vehicleRegNumber: "",
      chassisNumber: "",
      vinNumber: "",
      nationalIdNumber: "",
      passportNumber: "",
      driversLicenseNumber: "",
      breed: "",
      animalType: "",
      make: "",
    });
  }

  handleNext(e) {
    e.preventDefault();
    if (!this.validate()) {
      this.setState({
        msg: "Fix the errors above and try again.",
        toastColor: "danger",
      });
      return;
    }
    this.setState({ showVerify: true });
  }

  handleRegister(e) {
    e.preventDefault();
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }

    this.setState({ loading: true, msg: "", toastColor: "" });

    let request = new FormData();
    request.append("categoryId", this.state.category);
    request.append("subCategoryId", this.state.subcategory);
    if (Number(this.state.companyProfileId)) {
      request.append("companyProfileId", Number(this.state.companyProfileId));
    }
    if (Number(this.state.individualProfileId)) {
      request.append(
        "individualProfileId",
        Number(this.state.individualProfileId)
      );
    }
    if (this.state.year) {
      request.append("yearOfManufacture", this.state.year);
    }
    if (this.state.color) {
      request.append("color", this.state.color);
    }
    request.append("ownershipTypeId", this.state.proofOfOwnership);
    if (this.state.ownershipFile) {
      request.append("ownershipFile", this.state.ownershipFile);
    }
    if (this.state.ownershipDetails) {
      request.append("ownershipDetails", this.state.ownershipDetails);
    }
    request.append("locationOfMarker", this.state.locationOfMarker);
    if (this.state.descriptionOfMarker) {
      request.append("uniqueMarkerDescription", this.state.descriptionOfMarker);
    }
    if (this.state.markerPicture) {
      request.append("uniqueMarkerImage", this.state.markerPicture);
    }
    if (this.state.pictureOfAsset) {
      request.append("assetPicture", this.state.pictureOfAsset);
    }
    if (this.state.documentType) {
      request.append("documentTypeId", Number(this.state.documentType));
    }
    if (this.state.documentFile) {
      request.append("documentFile", this.state.documentFile);
    }

    request.append("brand", this.state.brand);
    request.append("model", this.state.model);
    request.append("serialNumber", this.state.serialNumber);
    request.append("tagNumber", this.state.tagNumber);
    request.append("vehicleRegNumber", this.state.vehicleRegNumber);
    request.append("chassisNumber", this.state.chassisNumber);
    request.append("vinNumber", this.state.vinNumber);
    request.append("nationalIdNumber", this.state.nationalIdNumber);
    request.append("passportNumber", this.state.passportNumber);
    request.append("driversLicenseNumber", this.state.driversLicenseNumber);
    request.append("breed", this.state.breed);
    request.append("animalType", this.state.animalType);
    request.append("make", this.state.make);

    let primaryName = "";
    let secondaryName = "";
    let uniqueIdentifier1 = "";
    let uniqueIdentifier2 = "";

    if (this.state.isForVehicles) {
      primaryName = this.state.make;
      secondaryName = this.state.model;
      uniqueIdentifier1 = this.state.vehicleRegNumber;
      uniqueIdentifier2 = this.state.chassisNumber;
    } else if (this.state.isForLivestock) {
      primaryName = this.state.animalType;
      secondaryName = this.state.breed;
      uniqueIdentifier1 = this.state.tagNumber;
      uniqueIdentifier2 = this.state.year;
    } else if (this.state.isForMobile) {
      primaryName = this.state.brand;
      secondaryName = this.state.model;
      uniqueIdentifier1 = this.state.uniqueIdentifier1;
      uniqueIdentifier2 = this.state.uniqueIdentifier2;
    } else if (this.state.isForElectronics) {
      primaryName = this.state.brand;
      secondaryName = this.state.model;
      uniqueIdentifier1 = this.state.serialNumber;
      uniqueIdentifier2 = this.state.uniqueIdentifier2;
    } else if (this.state.isForElectricals) {
      primaryName = this.state.brand;
      secondaryName = this.state.model;
      uniqueIdentifier1 = this.state.serialNumber;
      uniqueIdentifier2 = this.state.uniqueIdentifier2;
    } else if (this.state.isForMechanical) {
      primaryName = this.state.brand;
      secondaryName = this.state.model;
      uniqueIdentifier1 = this.state.tagNumber;
      uniqueIdentifier2 = this.state.year;
    } else if (this.state.isForFurniture) {
      primaryName = this.state.brand;
      secondaryName = this.state.model;
      uniqueIdentifier1 = this.state.tagNumber;
      uniqueIdentifier2 = this.state.year;
    } else if (this.state.isForTools) {
      primaryName = this.state.brand;
      secondaryName = this.state.model;
      uniqueIdentifier1 = this.state.tagNumber;
      uniqueIdentifier2 = this.state.year;
    } else if (this.state.isForTractors) {
      primaryName = this.state.brand;
      secondaryName = this.state.model;
      uniqueIdentifier1 = this.state.vehicleRegNumber;
      uniqueIdentifier2 = this.state.vinNumber;
    } else if (this.state.isForIdentityDocuments) {
      primaryName = this.state.nationalIdNumber;
      secondaryName = this.state.passportNumber;
      uniqueIdentifier1 = this.state.driversLicenseNumber;
      uniqueIdentifier2 = "";
    } else {
      primaryName = this.state.brand;
      secondaryName = this.state.model;
      uniqueIdentifier1 = this.state.uniqueIdentifier1;
      uniqueIdentifier2 = this.state.uniqueIdentifier2;
    }
    request.append("primaryName", primaryName);
    request.append("secondaryName", secondaryName);
    request.append("uniqueIdentifier1", uniqueIdentifier1);
    if (uniqueIdentifier2) {
      request.append("uniqueIdentifier2", uniqueIdentifier2);
    }

    axios
      .post(API + "/asset/save", request, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        if (response.data.success) {
          this.setState({
            msg: "Asset registered successfully!",
            toastColor: "success",
            loading: false,
          });
          window.location.href = "/asset/assets";
        } else {
          this.setState({
            msg: response.data.message || "Registration failed",
            toastColor: "danger",
            loading: false,
          });
        }
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          msg:
            error?.response?.data?.message ||
            "Registration failed. Please try again.",
          toastColor: "danger",
          loading: false,
        });
      });
  }

  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }

    if (s.loading) {
      return <Spinner className="" />;
    }

    return (
      <div className="min-h-screen flex justify-between bg-white">
        <Sidebar />
        <div className="min-h-screen w-[85%] flex flex-col">
          <Banner title={s.title} />
          {divMsg}
          {!s.showVerify ? (
            <form
              className="flex flex-col items-center w-full px-5 mt-2"
              autoComplete="off"
              onSubmit={this.handleNext}
            >
              <div className="w-full max-w-5xl">
                <div className="grid grid-cols-2 gap-x-8 gap-y-4">
                  <div className="input-group">
                    <label className="input-group-text">Category</label>
                    <select
                      name="category"
                      className={`form-control ${
                        s.errors.category ? " !border-red-500" : ""
                      }`}
                      value={s.category}
                      onChange={(e) =>
                        this.handleSelectChange("category", e.target.value)
                      }
                      required
                    >
                      <option value="">Select</option>
                      {s.categories.map((cat) => (
                        <option key={cat.name} value={cat.name}>
                          {cat.name}
                        </option>
                      ))}
                    </select>
                    {s.errors.category && (
                      <span className="input-group-error">
                        {s.errors.category}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Subcategory</label>
                    <select
                      name="subcategory"
                      className={`form-control ${
                        s.errors.subcategory ? " !border-red-500" : ""
                      }`}
                      value={s.subcategory}
                      onChange={(e) =>
                        this.handleSelectChange("subcategory", e.target.value)
                      }
                      required
                    >
                      <option value="">Select</option>
                      {s.subcategories.map((sub) => (
                        <option key={`subcategory-${sub.id}`} value={sub.id}>
                          {sub.name}
                        </option>
                      ))}
                    </select>
                    {s.errors.subcategory && (
                      <span className="input-group-error">
                        {s.errors.subcategory}
                      </span>
                    )}
                  </div>
                  {s.category && s.subcategory && (
                    <>
                      {!s.isForLivestock && !s.isForVehicles && (
                        <div className="input-group">
                          <label className="input-group-text">Brand</label>
                          <input
                            name="brand"
                            className={`form-control ${
                              s.errors.brand ? " !border-red-500" : ""
                            }`}
                            value={s.brand}
                            onChange={this.handleChange}
                            required
                          />
                          {s.errors.brand && (
                            <span className="input-group-error">
                              {s.errors.brand}
                            </span>
                          )}
                        </div>
                      )}
                      {!s.isForLivestock && (
                        <div className="input-group">
                          <label className="input-group-text">Model</label>
                          <input
                            name="model"
                            className={`form-control ${
                              s.errors.model ? " !border-red-500" : ""
                            }`}
                            value={s.model}
                            onChange={this.handleChange}
                            required
                          />
                          {s.errors.model && (
                            <span className="input-group-error">
                              {s.errors.model}
                            </span>
                          )}
                        </div>
                      )}
                      {s.isForLivestock && (
                        <>
                          <div className="input-group">
                            <label className="input-group-text">
                              Animal Type
                            </label>
                            <input
                              name="animalType"
                              className={`form-control ${
                                s.errors.animalType ? " !border-red-500" : ""
                              }`}
                              value={s.animalType}
                              onChange={this.handleChange}
                              required
                            />
                            {s.errors.animalType && (
                              <span className="input-group-error">
                                {s.errors.animalType}
                              </span>
                            )}
                          </div>
                          <div className="input-group">
                            <label className="input-group-text">Breed</label>
                            <input
                              name="breed"
                              className={`form-control ${
                                s.errors.breed ? " !border-red-500" : ""
                              }`}
                              value={s.breed}
                              onChange={this.handleChange}
                              required
                            />
                            {s.errors.breed && (
                              <span className="input-group-error">
                                {s.errors.breed}
                              </span>
                            )}
                          </div>
                        </>
                      )}
                      {s.isForVehicles && (
                        <div className="input-group">
                          <label className="input-group-text">Make</label>
                          <input
                            name="make"
                            className={`form-control ${
                              s.errors.make ? " !border-red-500" : ""
                            }`}
                            value={s.make}
                            onChange={this.handleChange}
                            required
                          />
                          {s.errors.make && (
                            <span className="input-group-error">
                              {s.errors.make}
                            </span>
                          )}
                        </div>
                      )}
                      {s.isForMobile && (
                        <div className="input-group">
                          <label className="input-group-text">IMEI 1</label>
                          <input
                            name="uniqueIdentifier1"
                            className={`form-control ${
                              s.errors.uniqueIdentifier1
                                ? " !border-red-500"
                                : ""
                            }`}
                            value={s.uniqueIdentifier1}
                            onChange={this.handleChange}
                            required
                          />
                          {s.errors.uniqueIdentifier1 && (
                            <span className="input-group-error">
                              {s.errors.uniqueIdentifier1}
                            </span>
                          )}
                        </div>
                      )}
                      {(s.isForElectronics || s.isForElectricals) && (
                        <div className="input-group">
                          <label className="input-group-text">
                            Serial Number
                          </label>
                          <input
                            name="serialNumber"
                            className={`form-control ${
                              s.errors.serialNumber ? " !border-red-500" : ""
                            }`}
                            value={s.serialNumber}
                            onChange={this.handleChange}
                            required
                          />
                          {s.errors.serialNumber && (
                            <span className="input-group-error">
                              {s.errors.serialNumber}
                            </span>
                          )}
                        </div>
                      )}
                      {(s.isForTools || s.isForLivestock) && (
                        <div className="input-group">
                          <label className="input-group-text">Tag Number</label>
                          <input
                            name="tagNumber"
                            className={`form-control ${
                              s.errors.tagNumber ? " !border-red-500" : ""
                            }`}
                            value={s.tagNumber}
                            onChange={this.handleChange}
                            required
                          />
                          {s.errors.tagNumber && (
                            <span className="input-group-error">
                              {s.errors.tagNumber}
                            </span>
                          )}
                        </div>
                      )}
                      {s.isForVehicles && (
                        <div className="input-group">
                          <label className="input-group-text">
                            Registration No
                          </label>
                          <input
                            name="vehicleRegNumber"
                            className={`form-control ${
                              s.errors.vehicleRegNumber
                                ? " !border-red-500"
                                : ""
                            }`}
                            value={s.vehicleRegNumber || ""}
                            onChange={this.handleChange}
                            required
                          />
                          {s.errors.vehicleRegNumber && (
                            <span className="input-group-error">
                              {s.errors.vehicleRegNumber}
                            </span>
                          )}
                        </div>
                      )}
                      {s.isForVehicles && (
                        <div className="input-group">
                          <label className="input-group-text">
                            Chasis / Vin Number
                          </label>
                          <input
                            name="chassisNumber"
                            className={`form-control ${
                              s.errors.chassisNumber ? " !border-red-500" : ""
                            }`}
                            value={s.chassisNumber || ""}
                            onChange={this.handleChange}
                          />
                          {s.errors.chassisNumber && (
                            <span className="input-group-error">
                              {s.errors.chassisNumber}
                            </span>
                          )}
                        </div>
                      )}
                      {s.isForTractors && (
                        <div className="input-group">
                          <label className="input-group-text">
                            Chasis / Vin Number
                          </label>
                          <input
                            name="vinNumber"
                            className="form-control"
                            value={s.vinNumber || ""}
                            onChange={this.handleChange}
                          />
                        </div>
                      )}
                      {s.isForIdentityDocuments && (
                        <>
                          <div className="input-group">
                            <label className="input-group-text">
                              National ID Number
                            </label>
                            <input
                              name="nationalIdNumber"
                              className="form-control"
                              value={s.nationalIdNumber || ""}
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="input-group">
                            <label className="input-group-text">
                              Passport Number
                            </label>
                            <input
                              name="passportNumber"
                              className="form-control"
                              value={s.passportNumber || ""}
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="input-group">
                            <label className="input-group-text">
                              Driver's License Number
                            </label>
                            <input
                              name="driversLicenseNumber"
                              className="form-control"
                              value={s.driversLicenseNumber || ""}
                              onChange={this.handleChange}
                            />
                          </div>
                        </>
                      )}
                      {s.isForLivestock && (
                        <div className="input-group">
                          <label className="input-group-text">Year</label>
                          <input
                            name="year"
                            className="form-control"
                            value={s.year}
                            onChange={this.handleChange}
                          />
                        </div>
                      )}
                      <div className="input-group">
                        <label className="input-group-text">Color</label>
                        <input
                          name="color"
                          className="form-control"
                          value={s.color}
                          onChange={this.handleChange}
                        />
                      </div>
                      {s.isForMobile && (
                        <div className="input-group">
                          <label className="input-group-text">IMEI 2</label>
                          <input
                            name="uniqueIdentifier2"
                            className="form-control"
                            value={s.uniqueIdentifier2}
                            onChange={this.handleChange}
                          />
                        </div>
                      )}
                      <div className="input-group">
                        <label className="input-group-text">
                          Proof of Ownership
                        </label>
                        <select
                          name="proofOfOwnership"
                          className={`form-control ${
                            s.errors.proofOfOwnership ? " !border-red-500" : ""
                          }`}
                          value={s.proofOfOwnership}
                          onChange={this.handleChange}
                          required
                        >
                          <option value="">Select</option>
                          {s.proofOfOwnershipOptions.map((opt) => (
                            <option
                              key={`ownership-type-${opt.id}`}
                              value={opt.id}
                            >
                              {opt.name}
                            </option>
                          ))}
                        </select>
                        {s.errors.proofOfOwnership && (
                          <span className="input-group-error">
                            {s.errors.proofOfOwnership}
                          </span>
                        )}
                      </div>
                      <div className="input-group">
                        <label
                          htmlFor="ownershipFile"
                          className="input-group-text"
                        >
                          Ownership File
                        </label>
                        <input
                          name="ownershipFile"
                          className={`form-control ${
                            s.errors.ownershipFile ? " !border-red-500" : ""
                          }`}
                          type="file"
                          id="ownershipFile"
                          onChange={this.handleFileChange}
                          accept=".pdf,image/*"
                          required
                        />
                        {s.errors.ownershipFile && (
                          <span className="input-group-error">
                            {s.errors.ownershipFile}
                          </span>
                        )}
                      </div>
                      <div className="input-group col-span-2">
                        <label className="input-group-text">
                          Ownership Details
                        </label>
                        <textarea
                          name="ownershipDetails"
                          className="form-control"
                          rows={2}
                          value={s.ownershipDetails}
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className="input-group col-span-2">
                        <label className="input-group-text">
                          Description of Marker
                        </label>
                        <textarea
                          name="descriptionOfMarker"
                          className="form-control"
                          rows={2}
                          value={s.descriptionOfMarker}
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className="input-group">
                        <label className="input-group-text">
                          Location of Marker
                        </label>
                        <input
                          name="locationOfMarker"
                          className={`form-control ${
                            s.errors.locationOfMarker ? " !border-red-500" : ""
                          }`}
                          value={s.locationOfMarker}
                          onChange={this.handleChange}
                          required
                        />
                        {s.errors.locationOfMarker && (
                          <span className="input-group-error">
                            {s.errors.locationOfMarker}
                          </span>
                        )}
                      </div>
                      <div className="input-group">
                        <label
                          htmlFor="markerPicture"
                          className="input-group-text"
                        >
                          Marker Picture
                        </label>
                        <input
                          name="markerPicture"
                          className="form-control"
                          type="file"
                          id="markerPicture"
                          onChange={this.handleFileChange}
                          accept="image/*"
                        />
                      </div>
                      <div className="input-group">
                        <label
                          htmlFor="pictureOfAsset"
                          className="input-group-text"
                        >
                          Picture of Asset
                        </label>
                        <input
                          name="pictureOfAsset"
                          className={`form-control ${
                            s.errors.pictureOfAsset ? " !border-red-500" : ""
                          }`}
                          type="file"
                          id="pictureOfAsset"
                          onChange={this.handleFileChange}
                          accept="image/*"
                          required
                        />
                        {s.errors.pictureOfAsset && (
                          <span className="input-group-error">
                            {s.errors.pictureOfAsset}
                          </span>
                        )}
                      </div>
                      {s.isForLivestock && (
                        <>
                          <div className="input-group">
                            <label className="input-group-text">
                              Document Type
                            </label>
                            <select
                              name="documentType"
                              className={`form-control ${
                                s.errors.documentType ? " !border-red-500" : ""
                              }`}
                              value={s.documentType}
                              onChange={this.handleChange}
                            >
                              <option value="">Select</option>
                              {s.documentTypeOptions.map((opt) => (
                                <option
                                  key={`document-type-${opt.id}`}
                                  value={opt.id}
                                >
                                  {opt.name}
                                </option>
                              ))}
                            </select>
                            {s.errors.documentType && (
                              <span className="input-group-error">
                                {s.errors.documentType}
                              </span>
                            )}
                          </div>
                          <div className="input-group">
                            <label
                              htmlFor="documentFile"
                              className="input-group-text"
                            >
                              Document File
                            </label>
                            <input
                              name="documentFile"
                              className="form-control"
                              type="file"
                              id="documentFile"
                              onChange={this.handleFileChange}
                              accept=".pdf,image/*"
                            />
                          </div>
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
              <div className="flex justify-center gap-8 mt-2">
                <button
                  type="submit"
                  className="btn btn-success"
                  disabled={!s.valid}
                >
                  Next
                </button>
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() => {
                    window.location = "/asset/assets";
                  }}
                >
                  Cancel
                </button>
              </div>
            </form>
          ) : (
            <div className="w-full max-w-5xl px-5 mt-2">
              <div className="grid grid-cols-2 gap-x-8 gap-y-4">
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="font-bold">Category</div>
                  <div>
                    {s.category || <span className="text-gray-400">-</span>}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="font-bold">Subcategory</div>
                  <div>
                    {s.subcategory || <span className="text-gray-400">-</span>}
                  </div>
                </div>
                {s.isForVehicles && (
                  <div className="flex flex-col gap-1 border-b pb-2">
                    <div className="font-bold">Make</div>
                    <div>
                      {s.make || <span className="text-gray-400">-</span>}
                    </div>
                  </div>
                )}
                {!s.isForLivestock && !s.isForVehicles && (
                  <>
                    <div className="flex flex-col gap-1 border-b pb-2">
                      <div className="font-bold">Brand</div>
                      <div>
                        {s.brand || <span className="text-gray-400">-</span>}
                      </div>
                    </div>
                  </>
                )}
                {!s.isForLivestock && (
                  <div className="flex flex-col gap-1 border-b pb-2">
                    <div className="font-bold">Model</div>
                    <div>
                      {s.model || <span className="text-gray-400">-</span>}
                    </div>
                  </div>
                )}
                {s.isForLivestock && (
                  <>
                    <div className="flex flex-col gap-1 border-b pb-2">
                      <div className="font-bold">Animal Type</div>
                      <div>
                        {s.animalType || (
                          <span className="text-gray-400">-</span>
                        )}
                      </div>
                    </div>
                    <div className="flex flex-col gap-1 border-b pb-2">
                      <div className="font-bold">Breed</div>
                      <div>
                        {s.breed || <span className="text-gray-400">-</span>}
                      </div>
                    </div>
                  </>
                )}
                {s.isForMobile && (
                  <div className="flex flex-col gap-1 border-b pb-2">
                    <div className="font-bold">IMEI 1</div>
                    <div>
                      {s.uniqueIdentifier1 || (
                        <span className="text-gray-400">-</span>
                      )}
                    </div>
                  </div>
                )}
                {(s.isForElectronics || s.isForElectricals) && (
                  <div className="flex flex-col gap-1 border-b pb-2">
                    <div className="font-bold">Serial Number</div>
                    <div>
                      {s.serialNumber || (
                        <span className="text-gray-400">-</span>
                      )}
                    </div>
                  </div>
                )}
                {(s.isForTools || s.isForLivestock) && (
                  <div className="flex flex-col gap-1 border-b pb-2">
                    <div className="font-bold">Tag Number</div>
                    <div>
                      {s.tagNumber || <span className="text-gray-400">-</span>}
                    </div>
                  </div>
                )}
                {s.isForVehicles && (
                  <div className="flex flex-col gap-1 border-b pb-2">
                    <div className="font-bold">Registration No</div>
                    <div>
                      {s.vehicleRegNumber || (
                        <span className="text-gray-400">-</span>
                      )}
                    </div>
                  </div>
                )}
                {s.isForVehicles && (
                  <div className="flex flex-col gap-1 border-b pb-2">
                    <div className="font-bold">Chasis / Vin Number</div>
                    <div>
                      {s.chassisNumber || (
                        <span className="text-gray-400">-</span>
                      )}
                    </div>
                  </div>
                )}
                {s.isForTractors && (
                  <div className="flex flex-col gap-1 border-b pb-2">
                    <div className="font-bold">VIN Number</div>
                    <div>
                      {s.vinNumber || <span className="text-gray-400">-</span>}
                    </div>
                  </div>
                )}
                {s.isForIdentityDocuments && (
                  <>
                    <div className="flex flex-col gap-1 border-b pb-2">
                      <div className="font-bold">National ID Number</div>
                      <div>
                        {s.nationalIdNumber || (
                          <span className="text-gray-400">-</span>
                        )}
                      </div>
                    </div>
                    <div className="flex flex-col gap-1 border-b pb-2">
                      <div className="font-bold">Passport Number</div>
                      <div>
                        {s.passportNumber || (
                          <span className="text-gray-400">-</span>
                        )}
                      </div>
                    </div>
                    <div className="flex flex-col gap-1 border-b pb-2">
                      <div className="font-bold">Driver's License Number</div>
                      <div>
                        {s.driversLicenseNumber || (
                          <span className="text-gray-400">-</span>
                        )}
                      </div>
                    </div>
                  </>
                )}
                {s.isForLivestock && (
                  <div className="flex flex-col gap-1 border-b pb-2">
                    <div className="font-bold">Year</div>
                    <div>
                      {s.year || <span className="text-gray-400">-</span>}
                    </div>
                  </div>
                )}
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="font-bold">Color</div>
                  <div>
                    {s.color || <span className="text-gray-400">-</span>}
                  </div>
                </div>
                {s.isForMobile && (
                  <div className="flex flex-col gap-1 border-b pb-2">
                    <div className="font-bold">IMEI 2</div>
                    <div>
                      {s.uniqueIdentifier2 || (
                        <span className="text-gray-400">-</span>
                      )}
                    </div>
                  </div>
                )}
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="font-bold">Proof of Ownership</div>
                  <div>
                    {s.proofOfOwnership || (
                      <span className="text-gray-400">-</span>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="font-bold">Ownership File</div>
                  <div>
                    {s.ownershipFile?.name || (
                      <span className="text-gray-400">-</span>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2 col-span-2">
                  <div className="font-bold">Ownership Details</div>
                  <div>
                    {s.ownershipDetails || (
                      <span className="text-gray-400">-</span>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2 col-span-2">
                  <div className="font-bold">Description of Marker</div>
                  <div>
                    {s.descriptionOfMarker || (
                      <span className="text-gray-400">-</span>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="font-bold">Location of Marker</div>
                  <div>
                    {s.locationOfMarker || (
                      <span className="text-gray-400">-</span>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="font-bold">Marker Picture</div>
                  <div>
                    {s.markerPicture?.name || (
                      <span className="text-gray-400">-</span>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="font-bold">Picture of Asset</div>
                  <div>
                    {s.pictureOfAsset?.name || (
                      <span className="text-gray-400">-</span>
                    )}
                  </div>
                </div>
                {s.isForLivestock && (
                  <>
                    <div className="flex flex-col gap-1 border-b pb-2">
                      <div className="font-bold">Document Type</div>
                      <div>
                        {s.documentType || (
                          <span className="text-gray-400">-</span>
                        )}
                      </div>
                    </div>
                    <div className="flex flex-col gap-1 border-b pb-2">
                      <div className="font-bold">Document File</div>
                      <div>
                        {s.documentFile?.name || (
                          <span className="text-gray-400">-</span>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </div>
              <div className="flex justify-center gap-8 mt-2">
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={this.handleRegister}
                >
                  Save
                </button>
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() => this.setState({ showVerify: false })}
                >
                  Back
                </button>
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() => {
                    window.location = "/asset/assets";
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          )}
          <Footer />
        </div>
      </div>
    );
  }
}
